module.exports = new __parcel__URL__("map.59b781b9.png").toString();